import { createContext } from "react";
import { LayerAdminServiceContextType } from "../../../types/LayerAdmin/OverviewContext";

export const LayerAdminServiceContext =
  createContext<LayerAdminServiceContextType | null>(null);
